(() => {
  if (window.occDesignRefresh) return;
  window.occDesignRefresh = true;
  const initialized = new WeakSet();
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function setup(root = document) {
    root.querySelectorAll('.od-products--carousel').forEach(rail => {
      if (initialized.has(rail)) return;
      initialized.add(rail);
      const section = rail.closest('.occ-design');
      const prev = section.querySelector('[data-od-prev]');
      const next = section.querySelector('[data-od-next]');
      if (!prev || !next) return;
      const sync = () => {
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 3;
      };
      prev.addEventListener('click', () => rail.scrollBy({left: -rail.clientWidth, behavior: reduced() ? 'instant' : 'smooth'}));
      next.addEventListener('click', () => rail.scrollBy({left: rail.clientWidth, behavior: reduced() ? 'instant' : 'smooth'}));
      rail.addEventListener('scroll', sync, {passive: true});
      const observer = new ResizeObserver(sync);
      observer.observe(rail);
      section.addEventListener('shopify:section:unload', () => observer.disconnect(), {once: true});
      sync();
    });
  }
  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:block:select', event => {
    const block = event.target;
    const rail = block.closest('.od-products--carousel');
    if (rail) rail.scrollTo({left: block.offsetLeft - rail.offsetLeft, behavior: 'instant'});
  });
})();
